<template>
    <rkm-table
        :items="data.model.servicosEnfermagem"
        :fields="fields.datatables.servicoEnfermagem"
    >
        <template v-slot:cell(procedimento.codigo)="{ value }">
            {{ value | formatProcedimento }}
        </template>

        <template v-slot:cell(actions)="{ index }">
            <rkm-button
                @click="handleDestroy(index)"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
// Mixins.
import formats from '@/filters/formats'

export default {
    computed: {
        fields() {

            return {
                datatables: {
                    servicoEnfermagem: [
                        { key: 'procedimento.codigo', label: 'Código', class: 'col-min', sortable: true },
                        { key: 'procedimento.nome', label: 'Nome', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min' },
                    ],
                }
            }
        }
    },
    filters: {
        formatProcedimento: formats.formatProcedimento,
    },
    methods: {
        handleDestroy(index) {

            const destroy = async () => this.data.model.servicosEnfermagem.splice(index, 1)

            this.showDeleteConfirmation('Deseja realmente excluir o serviço de enfermagem?', destroy)
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>